import Url from "../url/url";
import Cookies from "js-cookie";

export default class WpaCode {

    /**
     * WpaCode contructor
     *
     * @param {string} wpacode
     */
    constructor(wpacode) {
        this.wpacode = wpacode;
    }

    /**
     * Append the wpacode parameter to url
     *
     * @param {string} url
     *
     * @return {string}
     */
    appendToUrl(url) {
        const urlObject = new Url(url);

        if (urlObject.hasParameter('wpacode') || !urlObject.isValid()) {
            return url;
        }

        urlObject.setParameter('wpacode', this.wpacode);
        return urlObject.toString();
    }

    /**
     * Get the code
     *
     * @return {string}
     */
    getCode() {
        return this.wpacode;
    }

    /**
     * Get the current wpacode
     *
     * @return {WpaCode|null}
     */
    static getCurrent() {
        const wpacodeCookie = Cookies.get('generali_wpacode');

        if (typeof wpacodeCookie !== 'undefined') {
            return new WpaCode(wpacodeCookie);
        }

        return null;
    }

}